export const ChannelNames = [
    '성시경 SUNG SI KYUNG',
    '떡볶퀸 Tteokbokqueen',
    '지뉼랭가이드',
    '정육왕 MeatCreator',
    '김사원세끼',
    '회사랑RawFishEater',
    '김짬뽕',
    '조이한끼',
    '잡식공룡',
    '섬마을훈태TV',
    '맛있겠다 Yummy',
    '먹갱_Mukgang'
];
